export default __webpack_public_path__ + "static/media/microsoft-disabled.bfc2bf0d.svg";